import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ButtonBath = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Button type="primary" onClick={onClick}>
      {t('button.next')}
    </Button>
  );
};

export default ButtonBath;
